import { useDeliveryApi } from 'infrastructure/api';
import { ResourceData, useCrudService } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { changeRequestRejectValidation, changeRequestValidation } from './createupdate/changeRequestValidation';

const useChangeRequestService = () => {
  const singleResourceUrl = '/projects/:id';
  const {
    search: baseSearch,
    update: initialUpdate,
    ...baseCrudRequests
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: '/projects',
    useService: useDeliveryApi,
  });

  const { sendPostRequest, sendPutRequest, sendGetRequest, sendPatchRequest } = useDeliveryApi();

  const changeRequestsSearch = async (projectId: string, request: ResourceData): Promise<any> => {
    const searchParams = cloneDeep(request);
    const response = await sendPostRequest(`/projects/${projectId}/change-requests/search`, searchParams);
    return response.json();
  };

  const createChangeRequest = async (projectId: StringOrNumber, data: ResourceData): Promise<any> => {
    const response = await sendPostRequest(`/projects/${projectId}/change-requests`, data);
    return response.json();
  };

  const updateChangeRequest = async (id: StringOrNumber, data: ResourceData): Promise<any> => {
    const response = await sendPutRequest(`/change-requests/${id}`, data);
    return response.json();
  };

  const getChangeRequestById = async (resourceId: string): Promise<any> => {
    const response = await sendGetRequest(`/change-requests/${resourceId}`);
    return response.json();
  };
  const approveChangeRequest = async (id: string): Promise<any> => {
    const response = await sendPatchRequest(`/change-requests/${id}/approve`);
    return response.json();
  };
  const rejectChangeRequest = async (id: string, reason: string): Promise<any> => {
    const response = await sendPatchRequest(`/change-requests/${id}/reject`, { reason });
    return response.json();
  };

  const sendForSigningChangeRequest = async (id: string, request: ResourceData): Promise<any> => {
    const response = await sendPostRequest(`/change-requests/${id}/send-for-signing`, request);
    return response.json();
  };

  const getChangeRequestValidationSchema = () => Promise.resolve(changeRequestValidation);
  const getChangeRequestRejectValidationSchema = () => Promise.resolve(changeRequestRejectValidation);

  return {
    ...baseCrudRequests,
    changeRequestsSearch,
    createChangeRequest,
    updateChangeRequest,
    getChangeRequestById,
    approveChangeRequest,
    rejectChangeRequest,
    sendForSigningChangeRequest,
    getChangeRequestValidationSchema,
    getChangeRequestRejectValidationSchema,
  };
};

export default useChangeRequestService;
